import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportCollection from './Pages/ReportCollection';
import ReportDetails from './Pages/ReportDetails';
import { getMeldooWebSettings, getMeldooWebReports } from 'actions/MeldooWeb';
import NewReport from './Pages/NewReport';
import SearchReport from './Pages/SearchReport';
import { Helmet } from 'react-helmet';
import LoadingScreen from 'react-loading-screen';
import IntlMessages from 'util/IntlMessages';

class MeldooWeb extends Component {
	constructor(props) {
		super(props);
		this.state = {
			parameter: null,
			reportId: null,
			organisationKey: 'leanact',
			width: 0,
			height: 0
		};
	}

	componentDidMount() {
		window.location.href = `https://www.meldooplus.de/webV2/#/${
			this.props.match.params.organisationkey ? this.props.match.params.organisationkey : 'leanact'
		}${this.props.match.params.parameter ? `/${this.props.match.params.parameter}` : ''}${
			this.props.match.params.reportId ? `/${this.props.match.params.reportId}` : ''
		}`;

		const orgaKey = this.props.match.params.organisationkey ? this.props.match.params.organisationkey : 'leanact';

		this.setState({
			parameter: this.props.match.params.parameter,
			reportId: this.props.match.params.reportId,
			organisationKey: orgaKey
		});
		this.props.getMeldooWebSettings(orgaKey);
		this.props.getMeldooWebReports(orgaKey);
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
	}

	updateWindowDimensions = () => {
		this.setState({ width: window.innerWidth, height: window.innerHeight });
	};

	renderContent(showContent) {
		//		switch (this.props.match.params.parameter) {
		switch (showContent) {
			case 'details':
				return <ReportDetails reportId={this.props.match.params.reportId} organisationKey={this.state.organisationKey} />;
			case 'new':
				return <NewReport organisationKey={this.state.organisationKey} />;
			case 'search':
				return <SearchReport organisationKey={this.state.organisationKey} />;
			default:
				return <ReportCollection organisationKey={this.state.organisationKey} />;
		}
	}

	render() {
		const { body, main, accent, success, error, grey, navigation, steps, header, next, previous } = this.props.settings.colors;
		const { headerImage, headerTitle, headerSubTitle, backgroundImage } = this.props.settings.general;
		const { settings, connectionError } = this.props;
		let showContent = this.props.match.params.parameter;

		// Prüfen ob die Anzeige der Details erlaubt ist
		if (!settings.modules.reportDetails && showContent == 'details') {
			showContent = undefined;
			this.props.history.push(`/meldoo-web/${this.state.organisationKey}`);
		}

		// Prüfen ob die Anzeige der Suche erlaubt ist
		if (!settings.modules.reportSearch && showContent == 'search') {
			showContent = undefined;
			this.props.history.push(`/meldoo-web/${this.state.organisationKey}`);
		}

		// Prüfen ob die Anzeige der Übersicht erlaubt ist
		if (!settings.modules.reportCollection && showContent == undefined) {
			showContent = 'new';
			this.props.history.push(`/meldoo-web/${this.state.organisationKey}/new`);
		}

		return (
			<main
				className="app-main-content-wrapper d-flex align-items-center custom-body"
				style={{
					backgroundImage: `url(${backgroundImage})`,
					backgroundPosition: 'top',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat'
				}}
			>
				<LoadingScreen
					loading={this.props.loading.init}
					bgColor="#f1f1f1"
					spinnerColor="#2f75ba"
					textColor="#676767"
					logoSrc="assets/images/icon-meldoo.svg"
					text={connectionError ? <IntlMessages id="loginPage.maintainence" /> : 'Meldoo wird geladen...'}
				>
					<Helmet>
						<style>{`
						.custom-body {
							background-color: ${body.bg};
							color: ${body.font};
						}
						.custom-main {
							background-color: ${main.bg};
							color: ${main.font};
						}
						.border-main {
							border: 2px solid ${main.bg} !important;
						}
						.custom-accent {
							background-color: ${accent.bg} !important;
							color: ${accent.font} !important;
							border-color: ${accent.bg} !important;
						}
						.custom-success {
							background-color: ${success.bg};
							color: ${success.font};
						}
						.custom-error {
							background-color: ${error.bg};
							color: ${error.font};
						}
						.custom-grey {
							background-color: ${grey.bg};
							color: ${grey.font};
						}
						.custom-next {
							background-color: ${next.bg};
							color: ${next.font};
						}
						.custom-next:hover {
							background-color: ${next.hoverBg};
							color: ${next.hoverFont};
						}
						.custom-previous {
							background-color: ${previous.bg};
							color: ${previous.font};
						}
						.custom-previous:hover {
							background-color: ${previous.hoverBg};
							color: ${previous.hoverFont};
						}
						.text-blue {
							color: ${accent.bg} !important;
						}
						.btn-primary {
							background-color: ${next.bg} !important;
							border-color: ${next.font} !important;
						}
						.navigation-style {
							background-color: ${navigation.bg};
						}
						.navigation-style .breadcrumb-item, .navigation-style .breadcrumb-item::before {
							color: ${navigation.font};
						}
						.navigation-style a.breadcrumb-item {
							color: ${navigation.link}
						}
						.rc-steps-item-custom.rc-steps-item-process .rc-steps-item-icon > .rc-steps-icon, .rc-steps-item-finish .rc-steps-item-icon > .rc-steps-icon {
						    color: ${steps.stepDone};
						}
						.rc-steps-item-finish .rc-steps-item-tail:after {
							background-color: ${steps.stepDone};
						}
						.rc-steps-item-wait .rc-steps-item-icon > .rc-steps-icon {
							color: ${steps.stepOpen}
						}
						.rc-steps-item-wait .rc-steps-item-tail:after, .rc-steps-item-process .rc-steps-item-tail:after {
							background-color: ${steps.stepOpen}
						}
						.rc-steps-label-vertical .rc-steps-item-content {
							width: auto;
						}
						.isRequired {
							border: 1px solid ${accent.font};
						}
						@media only screen and (max-width: 1000px) {
							.minimum {
								min-width:95vw;
							}
						}
						@media only screen and (min-width: 1001px) {
							.minimum {
								min-width:950px;
							}
						}						
						`}</style>
					</Helmet>
					{settings.modules.reportHeader && (
						<div
							className="meldoo-web-header d-flex justify-content-center"
							style={{
								width: this.state.width,
								backgroundColor: header ? header.bg : '#fff'
							}}
						>
							<div
								style={{
									width: 1000,
									maxWidth: this.state.width
								}}
								className="row px-2"
							>
								<div className="col d-flex align-items-center">
									<div>{headerImage && <img src={headerImage} height="90" />}</div>
									<div
										className="pl-3"
										style={{
											color: header ? header.font : '#5c5c5c'
										}}
									>
										{headerTitle && <h1>{headerTitle}</h1>}
										{headerSubTitle && <p className="mb-0">{headerSubTitle}</p>}
									</div>
								</div>
							</div>
						</div>
					)}{' '}
					<div className="d-flex w-100 justify-content-center">
						<div className="app-main-content p-2 minimum" style={{ maxWidth: 1000 }}>
							{this.renderContent(showContent)}
						</div>
					</div>
					<div className="d-flex w-100 justify-content-center">
						<div className="row w-100 m-0 " style={{ paddingBottom: '20px', maxWidth: 1000 }}>
							<div className="col-md-6 col-sm-12">
								<img
									src="assets/images/logo-meldoo.svg"
									style={{
										float: 'left',
										height: '20px',
										paddingLeft: '8px'
									}}
								/>
							</div>
							<div
								className="col-md-6 col-sm-12"
								style={{
									textAlign: 'right',
									paddingRight: '25px'
								}}
							>
								<a target="_blank" href="https://www.leanact.de/impressum">
									Impressum
								</a>
								&nbsp; | &nbsp;
								<a target="_blank" href="https://www.leanact.de/agb-und-datenschutz/">
									Datenschutz
								</a>
							</div>
						</div>
					</div>
				</LoadingScreen>
			</main>
		);
	}
}

function mapStateToProps({ meldooWeb, auth }) {
	const { settings, loading } = meldooWeb;
	const { connectionError } = auth;
	return { settings, loading, connectionError };
}

export default connect(
	mapStateToProps,
	{ getMeldooWebSettings, getMeldooWebReports }
)(MeldooWeb);



// WEBPACK FOOTER //
// ./containers/MeldooWeb/index.js